import { Component, Input } from "@angular/core";

@Component({
  selector: "vw-badge",
  templateUrl: "./badge.component.html",
})
export class BadgeComponent {
  @Input({ required: true }) type!:
    | "badge-primary"
    | "badge-secondary"
    | "badge-success"
    | "badge-danger"
    | "badge-warning"
    | "badge-info"
    | "badge-light"
    | "badge-dark";
  @Input() text?: string;
  @Input() icon?: string;

  constructor() {}
}
